const thirdParty = {
  thirdParty: {
    pageHeader: 'サード・パーティ・レポート',
    clearState: '状態をクリア',
    register: '登録',
    systemRegistrationSummary: 'システム登録のサマリー',
    registrationProgress: '%{registration_in_progress} 進行中',
    registrationComplete: '%{registration_complete} 完了',
    thirdPartyLogin: 'サイトオーナーとしてログインし、PowerDash アカウントを管理してください',
    thirdPartyInvalidURI: '要求されたURIが無効であるか、システムなどの要求されたリソースが存在しません。'
  }
};

export default thirdParty;
